import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import ConfigData from '../../config.json';
import avatar1 from "../../assets/images/user-dummy-img.jpg";
import { useHistory } from "react-router-dom";
import { handlerRespError } from "../utility/handler_resp";
import CropImage from "../common/crop-image";


const EmployeeGeneral = ({data, onSave, onCancel}) => {
    const [objData, setObjData] = useState(data);
    const [selectGender, setSelectGender] = useState(null);
    const [ddlGender, setDdlGender] = useState([]);
    const [selectShirtSize, setSelectShirtSize] = useState(null);
    const [ddlShirtSize, setDdlShirtSize] = useState([]);
    const [employeePic, setEmployeePic] = useState(avatar1);
    const [fileEmployeePic, setFileEmployeePic] = useState(null);
    const [cropSelectPic, setCropSelectPic] = useState(null);
    const [cropShow, setCropShow] = useState(false);
    const history = useHistory();

    useEffect(() => {
        LoadDataDdlGender();
        LoadDataDdlShirtSize();
    }, []);

    useEffect(() => {
        setObjData(data);
        setEmployeePic((data.employee_pic != "" && data.employee_pic != null) ? ConfigData.IMAGE_URL + data.employee_pic : avatar1);
        setSelectGender(ddlGender.find(x => x.value === data.gender.toString()));
        setSelectShirtSize(ddlShirtSize.find(x => x.value === data.shirt_size.toString()));
    }, [data]);

    useEffect(() => {
        setSelectGender(ddlGender.find(x => x.value === data.gender.toString()));
        setSelectShirtSize(ddlShirtSize.find(x => x.value === data.shirt_size.toString()));
    }, [ddlGender, ddlShirtSize]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: objData.id || 0,
            employee_id:  objData.employee_id || "",
            name_th:  objData.name_th || "",
            name_en: objData.name_en || "",
            surname_th: objData.surname_th || "",
            surname_en: objData.surname_en || "",
            nickname_th: objData.nickname_th || "",
            nickname_en: objData.nickname_en || "",
            national_id: objData.national_id || "",
            gender: objData.gender || "",
            shirt_size: objData.shirt_size || "",
            birth_date: objData.birth_date || "",
            phone_number: objData.phone_number || "",
            employee_pic: objData.employee_pic || "",
        },
        validationSchema: Yup.object({
            name_th: Yup.string().required("Please enter a First name (TH)"),
            name_en: Yup.string().required("Please enter a First name (EN)"),
            surname_th: Yup.string().required("Please enter a Last name (TH)"),
            surname_en: Yup.string().required("Please enter a Last name (EN)"),
            nickname_th: Yup.string().required("Please enter a Nickname (TH)"),
            nickname_en: Yup.string().required("Please enter a Nickname (EN)"),
            employee_id: Yup.string().required("Please enter a Employee ID"),
            // phone_number: Yup.string().required("Please enter a Contact number"),
        }),
        onSubmit: (values) => {
            onSave(values, fileEmployeePic);
        }
    });

    const OnChangeEmployeePic = (e) => {
        if(e.target.files.length > 0){
            const file = e.target.files[0];
            if(file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png"){
                // setFileEmployeePic(file);
                // setEmployeePic(URL.createObjectURL(file));
                setCropSelectPic(URL.createObjectURL(file));
                setCropShow(true);
            }else{
                setFileEmployeePic(null);
                setEmployeePic(avatar1);
            }
        }
    };

    const OnCropCompleate = (filePic, urlPic) => {
        setFileEmployeePic(filePic);
        setEmployeePic(urlPic);
        setCropSelectPic(null);
        setCropShow(false);
    };

    const LoadDataDdlGender = () => {
        let url = ConfigData.API_URL + "gender/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlGender(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataDdlShirtSize = () => {
        let url = ConfigData.API_URL + "shirt-size/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlShirtSize(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Profile</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                        <div className="text-center">
                                            <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                                                <img src={employeePic} className="avatar-xl img-thumbnail user-profile-image" alt="user-profile" />
                                                <div className="avatar-xs p-0 profile-photo-edit">
                                                    <Input id="profile-img-file-input" type="file" className="profile-img-file-input" onChange={OnChangeEmployeePic} />
                                                    <Label htmlFor="profile-img-file-input" className="profile-photo-edit avatar-xs mb-0">
                                                        <span className="avatar-title bg-light text-body">
                                                            <i className="ri-camera-fill"></i>
                                                        </span>
                                                    </Label>
                                                </div>
                                            </div>
                                        </div>
                                        <CropImage image={cropSelectPic} isShow={cropShow} title="Profile picture" onComplete={OnCropCompleate} setShow={setCropShow} />
                                        {/* <div className="profile-user justify-content-center d-flex mb-3">
                                            <img className="avatar-xl img-thumbnail user-profile-image" alt="200x200" width="200" src={(validation.values.employee_pic !== "") ? ConfigData.IMAGE_URL + validation.values.employee_pic : avatar1} />
                                        </div> */}
                                    </Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtNameEn">First name (EN)</Label>
                                                    <Input id="txtNameEn" 
                                                        name="name_en"
                                                        placeholder="First name (EN)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.name_en || ""}
                                                        invalid={ validation.touched.name_en && validation.errors.name_en ? true : false }
                                                    />
                                                    { validation.touched.name_en && validation.errors.name_en ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.name_en}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtSurNameEn">Last name (EN)</Label>
                                                    <Input id="txtSurNameEn" 
                                                        name="surname_en"
                                                        placeholder="Last name (EN)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.surname_en || ""}
                                                        invalid={ validation.touched.surname_en && validation.errors.surname_en ? true : false }
                                                    />
                                                    { validation.touched.surname_en && validation.errors.surname_en ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.surname_en}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtNameTh">First name (TH)</Label>
                                                    <Input id="txtNameTh" 
                                                        name="name_th"
                                                        placeholder="First name (TH)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.name_th || ""}
                                                        invalid={ validation.touched.name_th && validation.errors.name_th ? true : false }
                                                    />
                                                    { validation.touched.name_th && validation.errors.name_th ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.name_th}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtSurNameTh">Last name (TH)</Label>
                                                    <Input id="txtSurNameTh" 
                                                        name="surname_th"
                                                        placeholder="Last name (TH)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.surname_th || ""}
                                                        invalid={ validation.touched.surname_th && validation.errors.surname_th ? true : false }
                                                    />
                                                    { validation.touched.surname_th && validation.errors.surname_th ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.surname_th}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtNickNameEn">Nickname (EN)</Label>
                                                    <Input id="txtNickNameEn" 
                                                        name="nickname_en"
                                                        placeholder="Nickname (EN)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.nickname_en || ""}
                                                        invalid={ validation.touched.nickname_en && validation.errors.nickname_en ? true : false }
                                                    />
                                                    { validation.touched.nickname_en && validation.errors.nickname_en ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.nickname_en}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtNickNameTh">Nickname (TH)</Label>
                                                    <Input id="txtNickNameTh" 
                                                        name="nickname_th"
                                                        placeholder="Nickname (TH)"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.nickname_th || ""}
                                                        invalid={ validation.touched.nickname_th && validation.errors.nickname_th ? true : false }
                                                    />
                                                    { validation.touched.nickname_th && validation.errors.nickname_th ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.nickname_th}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtEmployeeID">Employee ID</Label>
                                                    <Input id="txtEmployeeID" 
                                                        name="employee_id"
                                                        placeholder="Employee ID"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.employee_id || ""}
                                                        invalid={ validation.touched.employee_id && validation.errors.employee_id ? true : false }
                                                    />
                                                    { validation.touched.employee_id && validation.errors.employee_id ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.employee_id}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtNationalID">Identification No.</Label>
                                                    <Input id="txtNationalID" 
                                                        name="national_id"
                                                        placeholder="Identification No."
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.national_id || ""}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="ddlGender">Gender</Label>
                                                    <Select id="ddlGender"
                                                        name="gender"
                                                        value={selectGender}
                                                        onChange={(selected) => {
                                                            setSelectGender(selected);
                                                            validation.handleChange('gender')((selected !== null) ? selected.value : "");
                                                        }}
                                                        options={ddlGender}
                                                        isClearable={true}
                                                        isSearchable={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="ddlShirtSize">Shirt size</Label>
                                                    <Select id="ddlShirtSize"
                                                        name="shirt_size"
                                                        value={selectShirtSize}
                                                        onChange={(selected) => {
                                                            setSelectShirtSize(selected);
                                                            validation.handleChange('shirt_size')((selected !== null) ? selected.value : "");
                                                        }}
                                                        options={ddlShirtSize}
                                                        isClearable={true}
                                                        isSearchable={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtBirthDate">Date of birth</Label>
                                                    <Input id="txtBirthDate" 
                                                        name="birth_date"
                                                        placeholder="Date of birth"
                                                        type="date"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.birth_date || ""}
                                                        invalid={ validation.touched.birth_date && validation.errors.birth_date ? true : false }
                                                    />
                                                    { validation.touched.birth_date && validation.errors.birth_date ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.birth_date}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="txtContactNumber">Contact number</Label>
                                                    <Input id="txtContactNumber" 
                                                        name="phone_number"
                                                        placeholder="Contact number"
                                                        type="text"
                                                        className="from-control"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone_number || ""}
                                                        invalid={ validation.touched.phone_number && validation.errors.phone_number ? true : false }
                                                    />
                                                    { validation.touched.phone_number && validation.errors.phone_number ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.phone_number}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <div className="footer-div">
                            <div className="justify-content-center d-flex">
                                <Button color="primary" type="button" onClick={onCancel} >
                                    Close
                                </Button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button color="success" type="submit">
                                    Save
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </React.Fragment>
    )
};

export default EmployeeGeneral;